export default __webpack_public_path__ + "static/media/background.d964ec19.svg";